import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  appliedFilters: {
    id: 'omicsExplorer.summary.appliedFilters',
    defaultMessage: 'Applied Filters',
  },
  noDefaultFilters: {
    id: 'omicsExplorer.summary.noDefaultFilters',
    defaultMessage: 'No default filters have been created',
  },
  noFiltersExplanation: {
    id: 'omicsExplorer.summary.noFiltersExplanation',
    defaultMessage:
      'Omics Summary is currently displaying somatic variants and expressed genes curated in CKB as well as pathogenic germline variants as applicable. Create new default filters in Omics Explorer to customize variants populating Omics Summary.',
  },
  processing: {
    id: 'omicsExplorer.summary.processing',
    defaultMessage: 'Processing…',
  },
  nameTypeDate: {
    id: 'omicsExplorer.summary.nameTypeDate',
    defaultMessage: '{name} / {type} / {date}',
  },
  nameType: {
    id: 'omicsExplorer.summary.nameType',
    defaultMessage: '{name} / {type}',
  },
  variantDetail: {
    id: 'omicsExplorer.summary.variantDetail',
    defaultMessage: 'Variant Detail',
  },
  variantType: {
    id: 'omicsExplorer.summary.variantType',
    defaultMessage: 'Variant Type',
  },
  copyNumberValue: {
    id: 'omicsExplorer.summary.copyNumberValue',
    defaultMessage: 'CN={copyNumber}',
  },
  inFrameValue: {
    id: 'omicsExplorer.summary.inFrameValue',
    defaultMessage: 'In-Frame={inFrame}',
  },
  expression: {
    id: 'omicsExplorer.summary.expression',
    defaultMessage: 'Expression',
  },
  copyNumberVariant: {
    id: 'omicsExplorer.summary.copyNumberVariant',
    defaultMessage: 'Copy Number',
  },
  structuralVariant: {
    id: 'omicsExplorer.summary.structuralVariant',
    defaultMessage: 'Structural',
  },
  shortVariant: {
    id: 'omicsExplorer.summary.shortVariant',
    defaultMessage: 'Short',
  },
  sequenceTypeAndVariantType: {
    id: 'omicsExplorer.summary.sequenceTypeAndVariantType',
    defaultMessage: '{sequenceType} {variantType}',
  },
  truncationWarning: {
    id: 'omicsExplorer.summary.truncationWarning',
    defaultMessage:
      'Results have been removed from this summary because the maximum that can be displayed has been exceeded. Refine the default filters in order to decrease the number of results.',
  },
  currentDefault: {
    id: 'omicsExplorer.summary.currentDefault',
    defaultMessage: 'Current Default',
  },
});
